const $inject = [];

const locationIconFilter = () => {
  return (type) => {
    switch (type) {
      case 'Airport':
      case 'Airports':
        return 'ico-flight';
        break;

      case 'RailStation':
      case 'Rail Stations':
        return 'ico-rail';
        break;

      case 'PointOfInterest':
      case 'Points of Interests':
        return 'ico-ic-poi0';
        break;

      case 'Hotel':
      case 'Hotels':
        return 'ico-hotel0';
        break;

      default:
        return 'ico-marker';
        break;
    }
  };
};

locationIconFilter.$inject = $inject;

export default locationIconFilter;



// WEBPACK FOOTER //
// ./src/filters/locationIconFilter.js